<template>
  <div class="container pt-4">
    <div v-if="isShowQuote">
      <AlertNote v-if="checkNoteAlert()"></AlertNote>
      <!-- <div class="btn-group" v-if="!equipmentInfo">
            <button @click=backButtonClicked(action) class="btn main-button m-2 btn-sm">Back</button>
        </div> -->
      <div class="breadcrumbNavigation">
        <div @click="backPressed()">
          <ul class="breadcrumb custom-breadcrumb mb-0">
            <li v-for="(item, index) in crumbs" :key="index" class="breadcrumb-item">
              <a class="fw-medium text-decoration-none" @click="crumbClicked(item, index)">{{
                item
                }}</a>
            </li>
          </ul>
        </div>
      </div>
      <Notes v-if="notes"></Notes>
      <TabButtons></TabButtons>
      <ImageGallery :isBefore="1" v-if="gallery"></ImageGallery>
      <div v-if="quoteDetail != null && quoteDetail.trade.title == 'Hvac'">
        <HvacEquipmentInfo v-if="equipmentInfo"></HvacEquipmentInfo>
      </div>
      <div v-else>
        <EquipmentInfo v-if="equipmentInfo"></EquipmentInfo>
      </div>
      <QuoteItems v-if="quoteItems" :no_of_units="no_of_units"></QuoteItems>
      <QuoteSummary v-if="quoteSummary" :no_of_units="no_of_units"></QuoteSummary>
    </div>

    <div class="modal fade modal-md" id="modalMaintenance" ref="modalMaintenance" tabindex="-1"
      data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true" aria-labelledby="exampleModalLabel" aria-modal="true"
      role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content maintenanceModal p-0">
          <div class="modal-header d-block">
            <h5 class="mb-0 text-center fw-bold">HVAC Systems Under Maintenance</h5>
          </div>
          <div class="modal-body">
            <p class="mb-0 text-center">How many HVAC systems will be under maintenance in this claim?</p>
            <div class="system-options my-4">
              <label class="system-option">
                <input v-model="number_of_units" type="radio" name="system" value="1" checked>
                <div class="card selected">
                  <img src="../../assets/images/outdoor-1.png" alt="1 System">
                </div>
                <p>1 System</p>
              </label>
              <!-- Option 2 -->
              <label class="system-option">
                <input v-model="number_of_units" type="radio" name="system" value="2">
                <div class="card">
                  <img src="../../assets/images/outdoor-2.png" alt="2 System">
                </div>
                <p>2 Systems</p>
              </label>
            </div>
            <button @click="nextModalClicked()">Next</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Modal } from "bootstrap";
import { nextTick } from 'vue';
import Notes from "@/components/notes/Notes.vue";
import EquipmentInfo from "@/components/quote/EquipmentInfo.vue";
import HvacEquipmentInfo from "@/components/quote/HvacEquipmentInfo.vue";
import QuoteItems from "@/components/quote/QuoteItems.vue";
import QuoteSummary from "@/components/quote/QuoteSummary.vue";
import TabButtons from "@/components/tab-buttons/TabButtons.vue";
import ImageGallery from "@/components/image_gallery/ImageGallery.vue";
import AlertNote from "@/components/alert_note/AlertNote.vue";

export default {
  components: {
    Notes,
    EquipmentInfo,
    HvacEquipmentInfo,
    QuoteItems,
    QuoteSummary,
    TabButtons,
    ImageGallery,
    AlertNote
  },

  data() {
    return {
      crumbs: ["Quote Details", "Equipment Info"],
      isShowQuote: false,
      notes: true,
      equipmentInfo: true,
      gallery: true,
      quoteItems: false,
      quoteSummary: false,
      no_of_units: 1,
      is_show_multi_units: false,
      number_of_units: 1,
      isNumberOfUnitsDialogShow: false,
    };
  },
  computed: {
    ...mapGetters(["quoteDetail", "componentState"]),
  },

  watch: {

    quoteItems: function (data) {

    },

    quoteDetail: function (data) {

      if (data.status.technician.status == 0) {
        this.isShowQuote = true;
      } else {
        this.$router.push({ path: `/quote/detail/${this.quoteDetail.id}` });
      }
      // console.log("ttt quoteDetail", this.quoteItems);
      if(this.quoteItems && !this.isNumberOfUnitsDialogShow){
        this.isNumberOfUnitsDialogShow = true
           this.no_of_units = this.quoteDetail.number_of_units
            this.number_of_units = this.quoteDetail.number_of_units
            this.is_show_multi_units = this.quoteDetail.partner_info.is_show_multi_units

            if(this.is_show_multi_units){
              nextTick(() => {
              this.modal = new Modal(this.$refs.modalMaintenance);
              this.modal.show();
              document.documentElement.style.overflow = 'hidden'; // html
            })
            }
        
      }

    },

    componentState: function (data) {
      localStorage.setItem(
        this.$route.params.id + "-quote",
        JSON.stringify(data)
      );
      this.crumbs = [];
      this.crumbs.push("Quote Details");
      this.crumbs.push("Equipment Info");
      this.resetCommponent();
      console.log("ttt componentState", data);

      switch (data) {
        case "Notes":
          this.notes = true;
          this.equipmentInfo = true;
          this.gallery = true;
          break;
        case "QuoteItems":
          this.notes = true;

          this.crumbs.push("Quote Items");
          this.quoteItems = true;
          // if (this.quoteDetail)
          this.getQuoteDetail({
            manual_quote_id: this.$route.params.id,
          });
          console.log("ttt componentState - QuoteItems", this.quoteDetail);
          // if (this.isShowQuote) {
          //   this.no_of_units = this.quoteDetail.number_of_units
          //   this.number_of_units = this.quoteDetail.number_of_units
          //   this.is_show_multi_units = this.quoteDetail.partner_info.is_show_multi_units
          //   nextTick(() => {
          //     this.modal = new Modal(this.$refs.modalMaintenance);
          //     this.modal.show();
          //   })
          // }


          break;
        case "QuoteSummary":
          this.notes = true;
          this.quoteSummary = true;

          this.crumbs.push("Quote Items");
          this.crumbs.push("Summary");
          break;
      }
    },
  },

  mounted() {

    this.getQuoteDetail({
      manual_quote_id: this.$route.params.id,
    });
    var data =
      JSON.parse(localStorage.getItem(this.$route.params.id + "-quote")) ??
      "Notes";
    this.setCommponent(data);

    this.$refs.modalMaintenance.addEventListener('shown.bs.modal', () => {
      document.documentElement.style.overflow = 'hidden';
    });

    this.$refs.modalMaintenance.addEventListener('hidden.bs.modal', () => {
      document.documentElement.style.overflow = '';
    })
  },

  methods: {
    ...mapActions(["setCommponent", "getQuoteDetail"]),
    resetCommponent() {
      this.gallery = false;
      this.notes = false;
      this.equipmentInfo = false;
      this.quoteItems = false;
      this.quoteSummary = false;
    },

    nextModalClicked() {

      this.no_of_units = this.number_of_units
      this.modal.hide();
    },

    checkNoteAlert() {
      if (this.quoteDetail &&
        this.quoteDetail.partner_info
        && this.quoteDetail.partner_info.show_replacement_opportunity_badge == '1'
        && this.quoteDetail.partner_info.status == '1'
        && this.quoteDetail.partner_info.company_name != 'Vivint'
        && this.quoteDetail.partner_info.replacement_opportunity_number.length > 0) {
        return true
      } else {
        return false
      }
    },

    backButtonClicked() {
      switch (this.componentState) {
        case "QuoteItems":
          this.setCommponent("Notes");
          break;
        case "QuoteSummary":
          this.setCommponent("QuoteItems");
          break;
      }
    },

    crumbClicked(item) {
      if (item == "Equipment Info") {
        this.setCommponent("Notes");
      } else if (item == "Quote Items") {
        this.setCommponent("QuoteItems");
      } else if (item == "Quote Details") {
        this.$router.push({ path: `/quote/detail/${this.quoteDetail.id}` });
      }
    },
  },
};
</script>

<style>
.custom-breadcrumb {
  background-color: #fff;
}

.custom-breadcrumb a {
  margin: 5px 0 0;
  font-weight: 600;
}

.custom-breadcrumb .breadcrumb-item a {
  cursor: pointer;
  color: #ff5b01;
  text-decoration: underline;
}

.custom-breadcrumb .breadcrumb-item:last-child a {
  color: #7e7e7e;
  cursor: default;
  text-decoration: none;
}

.breadcrumbNavigation {
  padding: 1rem 0;
  border-bottom: 1px solid #ccc;
}

.maintenanceModal .modal-header {
  background: #ff5b01;
  border: 0;
  color: #fff;
}

.maintenanceModal .system-options {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.maintenanceModal .system-option input[type="radio"] {
  display: none;
}

.maintenanceModal .system-option p {
  margin: 1rem 0 0 0;
  text-align: center;
  color: #f44e00;
}

.maintenanceModal .card {
  border: 2px solid transparent;
  border-radius: 10px;
  padding: 15px;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: all 0.2s ease;
  cursor: pointer;
}

.maintenanceModal .card img {
  width: 150px;
  height: 120px;
  object-fit: contain;
}

.maintenanceModal .card p {
  color: #f44e00;
  font-weight: bold;
  margin-top: 8px;
}

.maintenanceModal .system-option input[type="radio"]:checked+.card {
  border-color: #f44e00;
  box-shadow: none;
}

.maintenanceModal button {
  margin: 0 auto;
  display: table;
  border: 0;
  padding: 0.5rem 3rem;
  border-radius: 50px;
  color: #fff;
  background: #f44e00;
}
</style>
